







import {Component, Vue} from 'vue-property-decorator';
import GlobalHeader from "@/components/GlobalHeader.vue";
import CollectionSlotBody from "@/components/collection-slot/CollectionSlotBody.vue";

@Component({
    components: {GlobalHeader, CollectionSlotBody}
})
export default class CollectionSlots extends Vue {}
